import { useEffect } from "react";

const DEFAULT_TITLE = "Fetchright — Find the dog that fits your life";
const DEFAULT_DESC =
  "Fetchright helps first-time and returning dog owners pick the right breed for their lifestyle, home, and budget — with an honest lifestyle quiz, cost calculator, and AI advisor.";

// Sets the document title + meta description for the current page and restores
// the defaults on unmount. Googlebot executes JS, so these are indexed per-URL.
export function usePageMeta(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    return () => {
      document.title = DEFAULT_TITLE;
      if (meta) meta.setAttribute("content", DEFAULT_DESC);
    };
  }, [title, description]);
}
